// extracted by mini-css-extract-plugin
module.exports = {"background":"pages-home-styles__background","gradient":"pages-home-styles__gradient","container":"pages-home-styles__container","description":"pages-home-styles__description"};